export default "__VITE_ASSET__JbkufAXz__"